module.exports = __webpack_public_path__ + "img/img_signout_amount_top@2x.0fb734bd.png";